import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private http: HttpClient) { }

  saveInvoice(id: any, data: any) {

    const { company, ...payload } = data
    const companyId = company?.id || company?._id || company;

    if (id) {
      return this.http.put(urls.API_URL + urls.INVOICES + `/${companyId}/${id}`, payload)
        .pipe(catchError(errorHandl));
    }

    return this.http.post(urls.API_URL + urls.INVOICES + '/' + companyId, payload)
      .pipe(catchError(errorHandl));

  }

  getInvoice(queryParams?:any) {
     const params = new HttpParams({ fromObject: queryParams});
    return this.http.get(urls.API_URL + urls.INVOICES, {params})
      .pipe(catchError(errorHandl));
  }

  getInvoiceById(id: any) {
    return this.http.get(urls.API_URL + urls.INVOICES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getInvoicePDf(companyId: any, id: any) {
  return this.http.get(urls.API_URL + urls.INVOICES + `/pdf/${companyId}/${id}`, {
    responseType: 'blob' as 'json'
  }).pipe(catchError(errorHandl));
}

   syncInvoice(compamyId:any, invoiceId:any, queryParams: any = {}) {
      const params = new HttpParams({ fromObject: queryParams || {} });
      return this.http.get(urls.API_URL + urls.INVOICES + `/${compamyId}/${urls.SYNC}/${invoiceId}`, { params })
        .pipe(catchError(errorHandl));
  }

   deleteInvoice(compamyId:any, invoiceId:any) {
      return this.http.delete(urls.API_URL + urls.INVOICES + `/${compamyId}/${invoiceId}`)
        .pipe(catchError(errorHandl));
  }

   sendEmail(compamyId:any, invoiceId:any) {
      return this.http.get(urls.API_URL + urls.INVOICES + `/send/`+ `${compamyId}/${invoiceId}`)
        .pipe(catchError(errorHandl));
  }
}
